module.exports = __webpack_public_path__ + "img/left-feet.13650060.png";